import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import {
  removeActionValue,
  resetTriggerActions,
  setRequiredError,
  setTriggerAction,
  setTriggerActionValue
} from '../../actions/triggerAction';
import {
  AGENCY_BUSINESS_TYPE,
  PERMISSION_LEVELS,
  PERMISSION_MODULES,
  PRIVACY_LEVEL,
  TRIGGER_TYPES,
  WITHOUT_CUSTOM_FIELDS
} from '../../../../helpers/CoreConstant';
import { Button, Typography } from '@material-ui/core';
import { fetchCustomFields } from '../../actions/commonAction';
import Utils from '../../../addContact/Utils';
import EachAction from './EachAction';
import { iconList } from '../../IconList';
import "../trigger-settings.css";

const mapStateToProps = state => ({
  loading: state.triggerSettingReducer.loading,
  triggerRule: state.triggerSettingReducer.triggerRule,
  personalize: state.triggerSettingReducer.personalize,
  data: state.triggerSettingReducer.data,
  previousActionValue: state.triggerSettingReducer.previousActionValue,
  triggerActionValue: state.triggerSettingReducer.triggerActionValue,
  triggerItemId: state.triggerSettingReducer.triggerItemId,
  needToResetActions: state.triggerSettingReducer.needToResetActions,
});

function mapDispatchToProps(dispatch) {
  return {
    setTriggerAction: triggerActionId =>
      dispatch(setTriggerAction(triggerActionId)),
    removeActionValue: rowIndex =>
      dispatch(removeActionValue(rowIndex)),
    setTriggerActionValue: param =>
      dispatch(setTriggerActionValue(param)),
    setRequiredError: param =>
      dispatch(setRequiredError(param)),
    fetchCustomFields: (param, callBack) =>
      dispatch(fetchCustomFields(param, callBack)),
    resetTriggerActions: param =>
      dispatch(resetTriggerActions(param)),
  };
}

const Action = props => {
  // mirror your constructor’s this.state
  const [state, setState] = useState({
    eachActionRow: [],
    show: false,
    selected_action_id: 0,
    selected_action: {},
    selected_action_values: {},
    selected_campaign_to_take_action: null,
    selected_tag_to_take_action: null,
    selected_collaborator_to_take_action: null,
    selected_pipeline_to_take_action: null,
    selected_stage_to_take_action: null,
    defaultCampaignOptions: [],
    defaultTagOptions: [],
    defaultCollaboratorOptions: [],
    defaultPipelineOptions: [],
    defaultStageOptions: [],
    deal_value: '',
    deal_closing_day: '',
    sms: '',
    mySmsCount: 0,
    to_sms: '',
    personalize: [],
    note: '',
    from_email: '',
    to_email: '',
    email_subject: '',
    email_body: '',
    textEditor: '',
    webhook_url: '',
    zapier_webhook_url: '',
    title: '',
    task_description: '',
    time: '12:00PM',
    duration: '00:15',
    taskTitle: 'call',
    task_id: 1,
    triggerItemId: props.triggerItemId,
  });

  const {
    loading,
    triggerRule,
    data,
    previousActionValue,
    triggerActionValue,
    needToResetActions,
  } = props;

  // replicate your constructor’s permission logic
    const hasGlobalFeaturePermission = Utils.getAccountData("agencyBusinessType") === AGENCY_BUSINESS_TYPE.INSURANCE || Utils.getAccountData("hasGlobalFeature");
  const canUserManageGlobalItem = window.hasPermission(
    PERMISSION_MODULES.MANAGE_GLOBAL_ITEMS,
    PERMISSION_LEVELS.WRITE
  );
  const isTriggerPrivate =
    triggerRule.privacy_level === PRIVACY_LEVEL.PRIVACY_LEVEL_PRIVATE;
  const isUserTriggerOwner =
    triggerRule.user_id === Utils.getAccountData("userId");
  const hasPermission =
    (hasGlobalFeaturePermission &&
      ((!isTriggerPrivate && canUserManageGlobalItem) ||
        (isTriggerPrivate && isUserTriggerOwner))) ||
    !hasGlobalFeaturePermission;

  // componentDidMount
  useEffect(() => {
    dataLoad();

    if (triggerRule.rule_trigger_action != null) {
      let eachActionRow = [];
      if (
        triggerRule.rule_trigger_action.user_trigger_actions.length > 0
      ) {
        triggerRule.rule_trigger_action.user_trigger_actions.map(
          (action, index) => {
            eachActionRow = eachActionRow.concat(
              <EachAction
                remover={removeAction}
                key={index}
                RowIndex={index}
              />
            );
          }
        );
        setState(s => ({ ...s, eachActionRow }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // only on mount

  // UNSAFE_componentWillReceiveProps
  useEffect(() => {
    if (needToResetActions) {
      // if you really want to clear rows, uncomment next line:
      // setState(s => ({ ...s, eachActionRow: [] }));
      props.resetTriggerActions(false);
    }
  }, [needToResetActions, props]);

  const dataLoad = () => {
    window
      .globalCustomFieldWithPersonalized({
        get_custom_data: true,
        get_personalized_data: true,
        field_name: ["*"],
      })
      .then(res => {
        let customFields = [];
        res.data.personalized_field.forEach(row => {
          customFields.push({
            label: row.title,
            value: row.personalize_tag,
          });
        });

        customFields.push({
          value: "blue",
          label: "User Customize Fields",
          color: "#f2f2f2",
          isDisabled: true,
        });

        res.data.custom_field.forEach(row => {
          customFields.push({
            label: row.title,
            value: row.personalize_tag,
          });
        });

        setState(s => ({
          ...s,
          personalize: WITHOUT_CUSTOM_FIELDS.concat(customFields),
        }));
      });
  };

  const removeAction = (e, rowIndex) => {
    e.preventDefault();
    if (rowIndex !== -1) {
      setState(s => {
        const eachActionRow = [...s.eachActionRow];
        eachActionRow.splice(rowIndex, 1);
        return { ...s, eachActionRow };
      });
      props.removeActionValue(rowIndex);
    }
  };

  const addNewAction = () => {
    setState(s => {
      const rowIndex = s.eachActionRow.length;
      return {
        ...s,
        eachActionRow: s.eachActionRow.concat(
          <EachAction
            newAction={true}
            remover={removeAction}
            key={rowIndex}
            RowIndex={rowIndex}
          />
        ),
      };
    });
  };

  // mirror your original render logic
  let newActionRowData = [];
  if (state.eachActionRow.length > 0) {
    state.eachActionRow.map((row, index) => {
      let more = {};
      try {
        const row_props = row.props;
        if (row_props.newAction !== undefined) {
          more["newAction"] = true;
        }
      } catch (error) {}
      newActionRowData.push(
        <EachAction
          actionValue={previousActionValue[index]}
          selectedActionValue={triggerActionValue[index]}
          remover={removeAction}
          personalize={state.personalize}
          key={index}
          RowIndex={index}
          {...more}
        />
      );
    });
  }

  return (
    <div style={{ width: "100%", padding: 20, borderLeft: "1px solid #e0e0e0" }}>
      {loading && (
        <div className="col-12 loader-min-height d-flex justify-content-center">
          <div className="align-self-center">
            <div className="text-center">
              {/* <Loader/> */}
            </div>
          </div>
        </div>
      )}

      {data && (
        <>
          <div
            style={{
              textAlign: "center",
              borderBottom: "1px solid #e0e0e0",
              paddingBottom: 20,
            }}
          >
            <Typography variant="h4" className="trigger__action_title">
              Actions
            </Typography>
          </div>

          <div className="trigger__setting_title alt w-100">
            <div className="d-flex justify-content-between align-items-center w-100">
              <h4 style={{ fontSize: 16, margin: 0 }}>
                Which action should we perform?
              </h4>

              <Button
                disabled={!hasPermission}
                onClick={addNewAction}
                className="trigger__blueBtn trigger__btn trigger__blueBtn addAction"
                style={{ height: 40 }}
              >
                {iconList.bluePlusIcon} Add Action
              </Button>
            </div>
          </div>
          <div style={{ overflowY: "auto", height: "580px" }}>
            {newActionRowData}
          </div>
        </>
      )}
    </div>
  );
};

const ActionItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(Action);

export default ActionItem;
